import axios from "../../../@core/axios"

export const getCompany = companyId => async dispatch => {
  try {
    const { data } = await axios.get(`/api/company/${companyId}`)
    localStorage.setItem("companyData", JSON.stringify(data))
    dispatch({ type: "GET_COMPANY", data })
  } catch (err) {
    console.log(err)
  }
}

export const updateCompany = (id, updatedData) => async dispatch => {
  try {
    const { data } = await axios.patch("/api/company", { id, updatedData })

    localStorage.setItem("companyData", data)

    dispatch({ type: "UPDATE_COMPANY", data })
  } catch (err) {
    console.log(err)
  }
}
